import React, { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { useI18n } from "@/i18n";
import { ASK_VYTALI_CLOSE, ASK_VYTALI_OPEN, openAskVytali } from "@/components/AskVytali";

const PHONE_HREF = "tel:+14185496833";

/** Mobile-only stacked quick actions. The desktop launcher lives in AskVytali. */
export default function MobileQuickActions() {
  const { t } = useI18n();
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setChatOpen(true);
    const onClose = () => setChatOpen(false);
    window.addEventListener(ASK_VYTALI_OPEN, onOpen);
    window.addEventListener(ASK_VYTALI_CLOSE, onClose);
    return () => {
      window.removeEventListener(ASK_VYTALI_OPEN, onOpen);
      window.removeEventListener(ASK_VYTALI_CLOSE, onClose);
    };
  }, []);

  if (chatOpen) return null;

  return (
    <div
      data-testid="mobile-quick-actions"
      className="fixed right-4 z-50 flex max-w-[calc(100vw-2rem)] flex-col items-end gap-3 sm:hidden"
      style={{ bottom: "calc(1rem + env(safe-area-inset-bottom, 0px))" }}
    >
      <a
        href={PHONE_HREF}
        data-testid="mobile-quick-phone"
        aria-label={t("chat.callAria")}
        className="flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full bg-accent text-accent-foreground shadow-lg transition-transform duration-200 active:scale-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-foreground"
      >
        <Phone className="h-5 w-5" aria-hidden="true" />
      </a>
      <button
        type="button"
        data-testid="mobile-quick-chat"
        onClick={openAskVytali}
        aria-label={t("chat.open")}
        className="flex min-h-[48px] shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary px-4 py-3 text-[15px] font-medium text-primary-foreground shadow-lg transition-transform duration-200 active:scale-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      >
        <MessageCircle className="h-5 w-5 shrink-0" aria-hidden="true" />
        <span>{t("chat.launcher")}</span>
      </button>
    </div>
  );
}
